/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Imgdesign_Err_Weight_Long1Inputs */

const vi_imgdesign_err_weight_long1 = /** @type {(inputs: Imgdesign_Err_Weight_Long1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trọng lượng tối đa ${i?.max} ký tự (vd 500g)`)
};

/**

* @param {Imgdesign_Err_Weight_Long1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const imgdesign_err_weight_long1 = /** @type {((inputs: Imgdesign_Err_Weight_Long1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imgdesign_Err_Weight_Long1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_imgdesign_err_weight_long1(inputs)
});
export { imgdesign_err_weight_long1 as "imgDesign_err_weight_long" }